interface SearchModel {
  language: string;
  cx: string;
  seo: SEOProps;
}

interface SEOProps {
    title: string;
    description: string;
    keywords?: string;
    author?: string;
    canonicalUrl?: string;
    ogImage?: string;
    locale?: string;
}

export type { SearchModel, SEOProps };
const defaultLanguage = "en";
const config: Record<string, SearchModel> = {
    "en": {
        language: "en",
        cx: "006249643689853114236:a3iibfpwexa",
        seo : {
            title: "Telegram Search. Find Telegram Channels, Bots & Groups.",
            description: "Discover Thousands Telegram Channels, Groups and bots easily. List one of your own Telegram join link for free in Telegram group.",
            keywords: "Telegram, TELEGRAM group, Telegram group search, tg search, find telegram group",
            author: "Xtea.io",
            canonicalUrl: "https://xtea.app/ts_en",
            ogImage: "https://xtea.app/logo512.png",
            locale: "en_US"
        }
    },
    "ir": {
        language: "ir",
        cx: "4afb39d8cac06c386",
        seo : {
            title: "جستجوی تلگرام. کانال ها، ربات ها و گروه های تلگرام را پیدا کنید.",
            description: "هزاران کانال، گروه و ربات تلگرام را به راحتی کشف کنید. یکی از لینک های عضویت در تلگرام خود را به صورت رایگان در گروه تلگرام قرار دهید.",
            keywords: "تلگرام، گروه تلگرام، جستجوی گروه تلگرام، جستجوی تی جی، یافتن گروه تلگرام",
            author: "Xtea.io",
            canonicalUrl: "https://xtea.app/ts_ir",
            ogImage: "https://xtea.app/logo512.png",
            locale: "fa_IR"
        }
    },
    "zh": {
        language: "zh",
        cx: "006249643689853114236:meozern20ky",
        seo : {
            title: "名刀电报搜索",
            description: "电报群组搜索，全网最全的群组索引。支持群组、聊天记录和账号搜索",
            keywords: "TELEGRAM,电报群,搜索,电报搜索,明刀",
            author: "Xtea.io",
            canonicalUrl: "https://xtea.app/ts_zh",
            ogImage: "https://xtea.app/logo512.png",
            locale: "zh_CN"
        }
    }
}

export function loadSearchModel(language: string = defaultLanguage) : SearchModel{
    return config[language];
}
